import logo from "../static/images/logo-desktop.png";

function useLogo(){
    return logo;
}

export default useLogo;